import React from "react";

const AlignmentToRetailersTargetSubtitle: React.FC = () => {
    return (
        <>
            Dash has evaluated how the types and numbers of
            retailers in your selected location compare to
            your targets, and how closely they align.
        </>
    );
};

export default AlignmentToRetailersTargetSubtitle;
